module.exports = __webpack_public_path__ + "static/media/exportcrediticon.80cde331.svg";